import React from "react";
import { Helmet } from "react-helmet";
import HeroSlider from "../components/HeroSlider";
import { useTranslation } from "react-i18next";

const Notary = () => {
  const {t} = useTranslation()
  return (
    <>
      <div className="home-page">
        <Helmet>
          <title>
            Notary | Min & Ying Legal Services Professional Corporation
          </title>
          
          <meta
            name="description"
            content="Notary | Min & Ying Legal Services Professional Corporation"
          />
        </Helmet>
        <HeroSlider/>
        {/* HERO=========== */}
        {/* <div className="container-fluid">
          <div className="row">
            <div className="hero-section">
              <div className="hero-overlay"></div>
              <div className="text-container d-flex flex-column justify-content-start align-items-start pt-6 slide">
                <div className="text-1 fs-2 pb-3 text-red-200">Min & Ying Legal Services Professional Corporation Professional Corporation222</div>
                <div className="text-2 fs-4">
                  BIROU DE AVOCAT SI INSOLVENTA
                  <span className="fw-bold">
                    <br></br> Bucuresti{" "}
                  </span>
                </div>
                <div className="text-3 fst-italic fw-light">
                  "Nu este o adevărată justiție acolo unde nu există dreptate,
                  iar dreptatea nu poate fi găsită acolo unde nu există adevăr."
                  - <span>Lucius Annaeus Seneca.</span>
                </div>
              </div>
            </div>
          </div>
        </div> */}

        {/*TE CONFRUNTI CU O PROBLEMA========= */}

        <section className="card py-5 px-3 border-0 container">
          <div className="row">
            <div className="col-lg-7">
              <div className="card-body">
                <h6 className="guide-text mb-4">{t('notary.title')}</h6>
                <p className="fw-normal">
                  {t('notary.notaryServiceIntro')}
                </p>
                <ul className="my-list" style={{paddingLeft: '0.5rem'}}>
                  <li><a href="#notary-service">{t('notary.title')}</a></li>
                  <li><a href="#apostille-service">{t('notary.hagueApostilleService')}</a></li>
                </ul>
                <p className="mt-5"><span className="font-weight-bold">{t('notary.notaryServices')}</span></p>
                <ul className="my-list" style={{paddingLeft: '0.5rem'}}>
                  <li>{t('notary.service1')}</li>
                  <li>{t('notary.service2')}</li>
                  <li>{t('notary.service3')}</li>
                  <li>{t('notary.service4')}</li>
                  <li>{t('notary.service5')}</li>
                  <li>{t('notary.service6')}</li>
                  <li>{t('notary.service7')}</li>
                </ul>
                <p className="mt-5"><span className="font-weight-bold">{t('notary.hagueApostilleService')}</span></p>
                <p>{t('notary.hagueApostilleIntro')}</p>
              </div>
            </div>

            <div className="col-lg-5 d-flex align-items-center justify-content-center">
              <div>
                <img
                  src="/assets/services/notary.webp"
                  className="intro-img img-fluid d-block rounded-2"
                  alt=" a gavel, scales of justice, and law books"
                  style={{ maxHeight: "300px" }}
                />
              </div>
            </div>
          </div>
        </section>

        {/* SERVICII========= */}
        <div className="">
          <div className="row">
            <div className="col">
              <div className="services-section" id="notary-service">
                <div className="services-overlay "></div>

                <div className="services-content container p-5 mobile-padding">
                  {/* <h6 className="guide-text font-weight-bold">Traffic Ticket Service</h6> */}
                  <h3 className="lh-base text-center pb-3">
                    {t('notary.notaryCommissionerService.title')}
                  </h3>
                  <p className="mt-3 text-center pb-5">
                    {t('notary.notaryCommissionerService.intro')}
                  </p>

                  <h6 className="guide-text font-weight-bold mt-5 mb-3">{t('notary.notaryCommissionerService.ourNotaryServices')}</h6>
                  <ul className="my-list" style={{paddingLeft: '0.5rem'}}>
                    <li>{t('notary.notaryCommissionerService.service1')}</li>
                    <li>{t('notary.notaryCommissionerService.service2')}</li>
                    <li>{t('notary.notaryCommissionerService.service3')}</li>
                  </ul>
                  
                  <h6 className="guide-text font-weight-bold mt-5 mb-3">{t('notary.notaryCommissionerService.ourCommissionerOfOathsServices')}</h6>
                  <ul className="my-list" style={{paddingLeft: '0.5rem'}}>
                    <li>{t('notary.notaryCommissionerService.help1')}</li>
                    <li>{t('notary.notaryCommissionerService.help2')}</li>
                    <li>{t('notary.notaryCommissionerService.help3')}</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="">
          <div className="row">
            <div className="col">
              <div className="" id="apostille-service">
                <div className="container p-5 mobile-padding">
                  {/* <h6 className="guide-text font-weight-bold">Company Ticket Service</h6> */}
                  <h3 className="lh-base text-center pb-3">
                    {t('notary.hagueApostilleConsularService.title')}
                  </h3>
                  <p className="mt-3 text-center pb-5">
                    {t('notary.hagueApostilleConsularService.intro')}
                  </p>
                  <h6 className="guide-text mt-5 mb-3">{t('notary.hagueApostilleConsularService.apostilleCertification')}</h6>
                  {/* <p>{t('notary.hagueApostilleConsularService.apostilleCertificationIntro')}</p> */}
                  <p>
                    {/* We offer a package, includes drafting document, translation by ATIO translator, notarization, and obtaining the certification of Apostille.</p> */}
                    {t('notary.hagueApostilleConsularService.weOffer')}:
                  </p>
                  <ul className="my-list" style={{paddingLeft: '0.5rem'}}>
                    <li>{t('notary.hagueApostilleConsularService.service1')}</li>
                    <li>{t('notary.hagueApostilleConsularService.service2')}</li>
                    <li>{t('notary.hagueApostilleConsularService.service3')}</li>
                    <li>{t('notary.hagueApostilleConsularService.service4')}</li>
                  </ul>
                  
                  <p>{t('notary.hagueApostilleConsularService.countriesSigned')}:</p>
                  <ul className="my-list" style={{paddingLeft: '0.5rem'}}>
                    <li>{t('notary.hagueApostilleConsularService.country1')}</li>
                    <li>{t('notary.hagueApostilleConsularService.country2')}</li>
                    <li>{t('notary.hagueApostilleConsularService.country3')}</li>
                    <li>{t('notary.hagueApostilleConsularService.country4')}</li>
                    <li>{t('notary.hagueApostilleConsularService.country5')}</li>
                    <li>{t('notary.hagueApostilleConsularService.country6')}</li>
                  </ul>
                  <div>
                    <div>{t('notary.hagueApostilleConsularService.forMoreCountriesReferenced')}:</div>
                    <a href="https://www.gsccca.org/notary-and-apostilles/apostilles/hague-apostille-country-list">https://www.gsccca.org/notary-and-apostilles/apostilles/hague-apostille-country-list</a>
                  </div>
                  <br/>
                  <p>{t('notary.hagueApostilleConsularService.hagueCertification')}</p>
                  <img alt="" src="/assets/services/apostille.png" style={{width: '400px', height:'auto'}} className="mb-3"/>
                  <p>{t('notary.hagueApostilleConsularService.hagueCertificationContent1')}</p>
                  <p>{t('notary.hagueApostilleConsularService.hagueCertificationContent2')}</p>
                  <p>{t('notary.hagueApostilleConsularService.hagueCertificationContent3')}</p>
                  <p>{t('notary.hagueApostilleConsularService.hagueCertificationContent4')}</p>
                  <p>{t('notary.hagueApostilleConsularService.hagueCertificationContent5')}</p>
                  <h6 className="guide-text font-weight-bold mt-5 mb-3">{t('notary.hagueApostilleConsularService.consularOrEmbassyLegalization')}</h6>
                  <p>{t('notary.hagueApostilleConsularService.consularOrEmbassyLegalizationIntro')}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Notary;
